// i18n ignore
/* eslint-disable import/no-webpack-loader-syntax */
import dts from '!!raw-loader!../wuji.d.ts';
import logger from '@/utils/logger';
import { globalConstantInjector } from './global-constant';
import { emailInjector } from './email';
import { wxworkInjector } from './wxwork';
/**
 * 所有注册的 DTS 注入器
 * 如需新增注入器，只需在此处添加即可
 */
const injectors = [
    globalConstantInjector,
    emailInjector,
    wxworkInjector,
];
/**
 * 执行单个注入器并返回结果
 */
async function executeInjector(injector, projectId) {
    const dtsContent = await injector.generate(projectId);
    return {
        placeholder: injector.placeholder,
        dts: dtsContent,
    };
}
/**
 * 应用注入结果到模板
 */
function applyInjections(template, results) {
    let result = template;
    for (const { placeholder, dts: dtsContent } of results) {
        result = result.replace(placeholder, dtsContent);
    }
    return result;
}
/**
 * 获取完整的类型定义
 * 并行执行所有注入器，提升性能
 *
 * @param projectId 项目ID
 * @returns 完整的类型定义字符串
 */
export async function getTypeDefinitions(projectId) {
    // 并行执行所有注入器
    const results = await Promise.all(injectors.map(injector => executeInjector(injector, projectId)));
    // 应用所有注入结果
    const mergedDts = applyInjections(dts, results);
    logger.log(mergedDts);
    return mergedDts;
}
// 导出注入器供外部使用
export { globalConstantInjector } from './global-constant';
export { emailInjector } from './email';
export { wxworkInjector } from './wxwork';
